export default __webpack_public_path__ + "img/OUYAJgKZ.5d264476.svg";